/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const FeetWalk = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M2 5.3c0 .9.1 1.8.4 2.7.2.7.5 1.4.9 2.1l.7 1.5 3.5-.7c-.3-1.7 0-2.3.3-3.1.4-.8.5-2 .3-3C7.6 2.3 6.3.2 4.5.5 3.3.8 2 2.2 2 5.3m9.9 3.8c-.3.9-.2 2.2.1 3.1.3.8.5 1.4.1 3.1l3.5.9.8-1.4c.4-.7.7-1.3 1-2.1.3-.9.5-1.8.5-2.7.1-3.1-1-4.6-2.2-4.9-1.7-.6-3.1 1.5-3.8 4m1.1 10c1 .3 1.9-.3 2.2-1.3l.2-.9-3.5-.9-.2.9c-.3 1 .3 2 1.3 2.2m-5.1-6.4l-.2-.9-3.5.7.2.9c.2 1 1.1 1.6 2.1 1.4.9-.2 1.6-1.1 1.4-2.1" />
  </svg>
);

export default extendIcon(FeetWalk);
